import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Icofont from 'react-icofont';
import { Row, Col, Container, Form, InputGroup, Button, Tab, Nav, Image, Badge } from 'react-bootstrap';
import CheckoutItem from './common/CheckoutItem';
import { parse } from "@fortawesome/fontawesome-svg-core";
import { liefershops } from '../utils.js';

class CheckoutOrder extends Component {
    constructor(props) {
        super(props);

        this.state = {
            totalItems: 0,
            checkOutItems: [],
            checkOutItemRefs: {},
            totalPrice: 0,
            pfandPrice: 0,
            addFun: null,
            removeFun: null,
            deleteFun: null,
            geschenkAktionen: [],
            buttonLink: (
                <h5 className="mb-1 text-white">Das Restaurant ist jetzt geschlossen!</h5>
            )
        };

        this.addProductItem = this.addProductItem.bind(this);
        this.removeProductItem = this.removeProductItem.bind(this);
        this.onAddFun = this.onAddFun.bind(this);
        this.onRemoveFun = this.onRemoveFun.bind(this);
        this.onDeleteFun = this.onDeleteFun.bind(this);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    componentDidUpdate(prevProps) {
        if (this.props.restaurantInfo?.id && this.props.restaurantInfo.id !== prevProps.restaurantInfo?.id) {
            this.fetchGeschenkAktionen(this.props.restaurantInfo.id);
        }
    }

    fetchGeschenkAktionen(partnerId) {
        if (!partnerId) return;
        fetch(liefershops(`api/v1/geschenk-aktion/?partner_id=${partnerId}`))
            .then((response) => response.json())
            .then((data) => {
                if (Array.isArray(data)) {
                    this.setState({ geschenkAktionen: data });
                }
            })
            .catch(() => {});
    }

    getQualifyingGifts() {
        const { totalPrice } = this.state;
        return this.state.geschenkAktionen.filter(
            (g) => totalPrice >= parseFloat(g.mindestbestellwert)
        );
    }

    setFunctions(addFunction, removeFunction, deleteFunction) {
        let state = this.state;

        state.addFun = addFunction;
        state.removeFun = removeFunction;
        state.deleteFun = deleteFunction;

        this.setState(state);
    }

    onAddFun(product) {
        const state = this.state;

        product.setState({ quantity: product.state.quantity + 1 });

        this.props.itemsCarousel.current.addSaveProduct(this.props.restaurantInfo.id, product.props.title, product.getPrice(), product.getPricePfand(), product.props.id);

        this.setState(state);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    onRemoveFun(product) {
        const state = this.state;

        product.setState({ quantity: product.state.quantity - 1 });

        this.props.itemsCarousel.current.removeSaveProduct(this.props.restaurantInfo.id, product.props.title, product.getPrice());

        this.setState(state);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    onDeleteFun(product) {
        product.setState({ quantity: 0 });

        const lastRestaurant = JSON.parse(localStorage.getItem("last-restaurant") || "{}");
        if (Object.keys(lastRestaurant).length === 0) {
            return;
        }

        const products = JSON.parse(localStorage.getItem(`restaurant-products-${lastRestaurant.id}`) || "{}");
        if (Object.keys(products).length === 0) {
            return;
        }

        delete products[product.props.title];

        localStorage.setItem(`restaurant-products-${lastRestaurant.id}`, JSON.stringify(products));

        this.removeProductItem(product);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    setProductItem(product, amount) {
        let state = this.state;
        let title = product.props.title;

        const productId = product.props.id;
        const productTitle = product.props.title;

        const exists = state.checkOutItems.some(
            (element) => element.props.id === productId
        );

        if (!exists) {
            let elementRef = React.createRef();
            let element = (
                <CheckoutItem
                    key={`checkoutitem-${product.props.id}`}
                    id={product.props.id}
                    itemName={product.props.title}
                    nummer={product.props.product?.nummer}
                    price={product.getPrice()}
                    priceUnit="€"
                    qty={amount}
                    show={true}
                    minValue={0}
                    maxValue={40}
                    getValue={() => {
                    }}
                    ref={elementRef}
                    addFun={this.onAddFun}
                    removeFun={this.onRemoveFun}
                    deleteFun={this.onDeleteFun}
                    product={product}
                />
            );

            state.totalItems += amount;

            state.checkOutItems.push(element);
            state.checkOutItemRefs[title] = elementRef;

            setTimeout(() => {
                this.state.checkOutItems.forEach((product) => this.loadExtras(product));
            }, 50);
        }

        this.setState(state);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    addProductItem(product) {
        let state = this.state;
        let title = product.props.title;
        let hasValue = false;

        const productId = product.props.id;
        const productTitle = product.props.title;
        const exists = state.checkOutItems.some(
            (element) => element.props.id === productId
        );

        state.checkOutItems.forEach((element) => {
            if (hasValue)
                return;

            if (element.props.itemName === product.props.title) {
                hasValue = true;

                return;
            }
        });

        if (exists) {
            let elementRef = state.checkOutItemRefs[productTitle];
            if (elementRef)
                elementRef.current.addQty();
        } else {
            let elementRef = React.createRef();
            let element = (
                <CheckoutItem
                    key={`checkoutitem-${productId}`}
                    id={productId}
                    itemName={productTitle}
                    nummer={product.props.product?.nummer}
                    price={product.getPrice()}
                    priceUnit="€ "
                    qty={product.state.quantity}
                    show={true}
                    minValue={0}
                    maxValue={40}
                    getValue={() => {
                    }}
                    ref={elementRef}
                    addFun={this.onAddFun}
                    removeFun={this.onRemoveFun}
                    deleteFun={this.onDeleteFun}
                    product={product}
                />
            );

            state.totalItems += 1;

            state.checkOutItems.push(element);
            state.checkOutItemRefs[title] = elementRef;
        }

        // state.totalPrice += product.getPrice();

        this.setState(state);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    removeProductItem(product) {
        let state = this.state;
        let title = product.props.title;

        let elementRef = state.checkOutItemRefs[title];
        if (elementRef) {
            let current = elementRef.current;
            current.removeQty();

            if (current.state.quantity <= 0) {
                delete state.checkOutItemRefs[title];
                state.totalItems -= 1;

                state.checkOutItems.forEach((element) => {
                    if (element.props.itemName !== title)
                        return;

                    let index = state.checkOutItems.indexOf(element);
                    if (index === -1)
                        return;

                    state.checkOutItems.splice(index, 1);
                });
            }
        }

        if (state.totalPrice < 0)
            state.totalPrice = 0;

        this.setState(state);

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    openRestaurant() {
        let state = this.state;

        state.buttonLink = (
            <Link to="/checkout" className="btn btn-success btn-block btn-lg">Bezahlen
                {/* <Icofont icon="long-arrow-right"/> */}</Link>
        );

        this.setState(state);
    }

    loadExtras(product) {

        this.state.checkOutItems.forEach((element) => {
            if (element.props.itemName !== product.props.title)
                return;

            let elementRef = this.state.checkOutItemRefs[product.props.title];
            if (elementRef) {
                elementRef.current.loadExtras(product);
            }
        });

        setTimeout(() => {
            this.updateTotalPrice();
        }, 100);
    }

    updateTotalPrice() {
        // let totalPrice = 0;
        //
        // Object.values(this.state.checkOutItemRefs).forEach(ref => {
        //     if (ref.current) {
        //         const currentCheckOut = ref.current;
        //         totalPrice += parseFloat(currentCheckOut.getTotalPrice());
        //     }
        // });
        //
        // this.setState({ totalPrice: isNaN(totalPrice) ? 0 : totalPrice });

        let totalPrice = 0;
        let pfandPrice = 0;

        Object.values(this.state.checkOutItemRefs).forEach(ref => {
            if (ref.current) {
                const currentCheckOut = ref.current;

                // Основна ціна
                if (typeof currentCheckOut.getTotalPrice === 'function') {
                    totalPrice += parseFloat(currentCheckOut.getTotalPrice());
                }

                // Pfand ціна — лише якщо метод існує
                if (typeof currentCheckOut.getTotalPfandPrice === 'function') {
                    pfandPrice += parseFloat(currentCheckOut.getTotalPfandPrice());
                }
            }
        });

    this.setState({
        totalPrice: isNaN(totalPrice) ? 0 : totalPrice,
        pfandPrice: isNaN(pfandPrice) ? 0 : pfandPrice
    });
    }

    getTotalPrice() {
        // const totalFixedPrice = this.state.totalPrice;
        //
        // if (totalFixedPrice >= this.props.rabattFestAb && this.props.rabattFest !== 0) {
        //     const totalPriceWithRabattFest = totalFixedPrice - totalFixedPrice * Math.abs(this.props.rabattFest) / 100;
        //     return totalPriceWithRabattFest.toFixed(2);
        // }
        //
        // const totalPriceWithRabatt = totalFixedPrice - totalFixedPrice * Math.abs(this.props.rabbat) / 100;
        // return totalPriceWithRabatt.toFixed(2);

        const { totalPrice, pfandPrice } = this.state;

        let discountedPrice = totalPrice;

        // Якщо діє фіксована знижка
        if (totalPrice >= this.props.rabattFestAb && this.props.rabattFest !== 0) {
            discountedPrice = totalPrice - totalPrice * Math.abs(this.props.rabattFest) / 100;
        } else {
            discountedPrice = totalPrice - totalPrice * Math.abs(this.props.rabbat) / 100;
        }

        const totalWithPfand = discountedPrice + pfandPrice;

        return totalWithPfand.toFixed(2);
    }

    getDiscount() {
        // const state = this.state;
        // const discount = state.totalPrice - this.getTotalPrice();
        //
        // return discount.toFixed(2);

        const { totalPrice } = this.state;

        let discountedPrice = totalPrice;

        if (totalPrice >= this.props.rabattFestAb && this.props.rabattFest !== 0) {
            discountedPrice = totalPrice - totalPrice * Math.abs(this.props.rabattFest) / 100;
        } else {
            discountedPrice = totalPrice - totalPrice * Math.abs(this.props.rabbat) / 100;
        }

        const discount = totalPrice - discountedPrice;
        return discount.toFixed(2);

    }

    scrollToCart = () => {
        const el = document.getElementById("ls-cart");
        if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    render() {
        return (
            <>
            {/* Mobile-only shortcut to the basket.
                On phones the basket column stacks underneath the full menu, so
                on a large menu the customer had to scroll past every single
                dish (~150 for some restaurants) before they could reach the
                order summary and the pay button. This fixed bar keeps the
                running total and a jump-to-basket action permanently in reach.
                Hidden from lg upwards, where the basket already sits in the
                right-hand column. */}
            {this.state.totalItems > 0 ? (
                <div className="ls-mobile-cart-bar d-lg-none" onClick={this.scrollToCart} role="button" tabIndex={0}
                     onKeyPress={this.scrollToCart}>
                    <span className="ls-mobile-cart-bar__count">
                        <Icofont icon="cart" /> {this.state.totalItems} Artikel
                    </span>
                    <span className="ls-mobile-cart-bar__total">
                        {this.getTotalPrice()} € <Icofont icon="simple-up" />
                    </span>
                </div>
            ) : null}
            <div id="ls-cart" className="generator-bg rounded shadow-sm mb-4 p-3 osahan-cart-item sticky-nav">
                <h5 className="mb-1 text-white">Ihre Bestellung</h5>
                <p className="mb-4 text-white">{this.state.totalItems} Artikel</p>
                <div className="bg-white rounded shadow-sm mb-2">
                    {this.state.checkOutItems}
                </div>

                {this.getQualifyingGifts().length > 0 ? (
                    <div className="mb-2 bg-white rounded p-2">
                        <h6 className="text-success mb-1"><Icofont icon="gift" /> Geschenk!</h6>
                        {this.getQualifyingGifts().map((g) => (
                            <p key={g.id} className="mb-1 text-sm">{g.geschenk_name}{g.beschreibung ? ` - ${g.beschreibung}` : ''}</p>
                        ))}
                    </div>
                ) : this.state.geschenkAktionen.length > 0 ? (
                    <div className="mb-2 bg-white rounded p-2">
                        <p className="mb-0 text-muted" style={{fontSize: '12px'}}>
                            <Icofont icon="gift" /> Ab {Math.min(...this.state.geschenkAktionen.map(g => parseFloat(g.mindestbestellwert))).toFixed(2)} € gibt es ein Geschenk!
                        </p>
                    </div>
                ) : ''}

                <div className="mb-2 bg-white rounded p-2 clearfix">
                    <Image fluid className="float-left" src="/img/wallet-icon.png" />
                    <p className="text-right mb-2">Summe <span
                        className="text-gray">{this.state.totalPrice.toFixed(2)} €</span>
                    </p>
                    <p className=" text-right mb-2">Total Rabatt : <span className="text-gray">{this.getDiscount()} €</span>
                    </p>
                    <p className="text-right mb-2">Summe Pfand <span
                        className="text-gray">{this.state.pfandPrice.toFixed(2)} €</span>
                    </p>
                    <h6 className="font-weight-bold text-right mb-2">Gesamt  : <span
                        className="text-danger">{this.getTotalPrice()} €</span></h6>
                    <p className="text-right" style={{ fontSize: "12px" }}>inkl. MwSt.</p>
                    <p className=" text-right mb-2">zzgl. Lieferkosten : <span className="text-gray">{parseFloat(this.props.lieferkosten).toFixed(2)} €</span>
                    </p>

                </div>

                {this.getTotalPrice() >= Math.abs(this.props.mindestbestellwert) ? this.state.buttonLink :
                    <h5 className="mb-1 text-white">Mindestbestellwert
                        ist {Math.abs(this.props.mindestbestellwert)} €</h5>}
                {/*<h5 className="mb-1 text-white">Lieferkosten*/}
                {/*        ist {parseFloat(this.props.lieferkosten).toFixed(2)} €</h5>*/}
                {/*
        <Link to="/checkout" className="btn btn-success btn-block btn-lg">Checkout<Icofont icon="long-arrow-right" /></Link> 
        */}
                <div className="pt-2"></div>
            </div>
            </>
        );
    }
}

CheckoutOrder.propTypes = {
    rabbat: PropTypes.number.isRequired,
    rabattFestAb: PropTypes.number.isRequired,
    rabattFest: PropTypes.number.isRequired,
    lieferkosten: PropTypes.number.isRequired,
    mindestbestellwert: PropTypes.number.isRequired,
    itemsCarousel: PropTypes.any.isRequired,
    restaurantInfo: PropTypes.any.isRequired
};

export default CheckoutOrder;